import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  computed, inject,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Text',
  props: {
    textAlign: { default: 'center' },
    color: { default: 'dark' },
    fontSize: { default: 'regular' },
    colorLg: { default: 'dark' }
  },
  setup(__props: any) {

const props = __props;

const alignment = inject<string>('cardItemsAlign', props.textAlign);

const classes = computed(() => {
  const textClasses = [];

  textClasses.push(`color-${props.color}`);
  textClasses.push(`color-lg-${props.colorLg}`);
  textClasses.push(`fs-${props.fontSize}`);

  return textClasses;
});

const style = computed(() => {
  const styles = {} as Record<string, string>;

  if (alignment !== 'inherit') {
    styles['--base-text-align'] = props.textAlign as string;
  }

  return styles;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["io-text", classes.value]),
    style: _normalizeStyle(style.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})